<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row" v-if="font">
                <div class="col-md-6">
                    <card>
                        <h4 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h4>
                        <form>
                            <div class="loader" v-if="waiting"></div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="premium-control"
                                               class="control-label label-checkbox">Премиум</label>
                                        <input v-model="font.is_premium" id="premium-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="font.category_id"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="c in categories" v-bind:value="c.id">
                                                {{ c.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="font.status"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Активен</option>
                                            <option value="0">Не активен</option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Название"
                                              v-model="font.name"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Сортировка (чем больше, тем выше в списке)"
                                              v-model="font.sort"
                                              placeholder="">
                                    </fg-input>
                                </div>
                                <div class="col-md-6 buttons-block">
                                    <h4 slot="header" class="card-title">
                                        Шрифт: <span v-if="font.src">
                                            <span class="inline-link">
                                                <span v-if="font.src_size >= 1"
                                                      class="bg-danger">{{ font.src_size }}Mb</span>
                                                <span v-else-if="font.image_src_size >= 0.5"
                                                      class="bg-warning">{{ font.src_size }}Mb</span>
                                                <span v-else>{{ font.src_size }}Mb</span>
                                                <a :href="font.src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                    </h4>

                                    <div>
                                        <input ref="imageFileInput" class="btn-file" type="file"
                                               @change="uploadFile($event, 'font')">
                                        <button type="button" class="btn btn-info btn-fill upload-button"
                                                @click="$refs.imageFileInput.click()">
                                            Загрузить
                                        </button>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!font.category_id || !font.name || !font.src"
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

const moment = require('moment')
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    name: 'EditAlbum',
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            font: null,
            locales: [],
            categories: [],
        }
    },
    created: function () {
        this.id = this.$route.params.id;
        this.getCategories();
    },
    methods: {
        goBack: function () {
            this.$router.push('/fonts');
        },
        getCategories: function () {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/fonts/categories`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.categories = JSON.parse(JSON.stringify(response.data));

                    self.get(self.id);
                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        get: function (id) {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/fonts/${this.id}`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    let data = JSON.parse(JSON.stringify(response.data));

                    self.font = data;

                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        save: function () {
            let self = this;

            let font = JSON.parse(JSON.stringify(this.font));

            self.waiting = true;

            axios.post(
                `${this.$hostname}/admin/fonts/${this.id}/update`,
                font,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    const notification = {
                        template: `<span><b>Шрифт был успешно обновлен</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-explore-2',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'info'
                        })

                    self.waiting = false;
                })
                .catch(function (error) {
                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    self.waiting = false;
                });
        },
        uploadFile: function (event, type) {
            let self = this;

            let formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            axios.post(
                `${this.$hostname}/admin/services/file/upload`,
                formData,
                {
                    params: {
                        file_type: type
                    },
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {

                self.waiting = false;

                let data = JSON.parse(JSON.stringify(response.data));

                self.font.src = data.url;
                self.font.src_full = data.url_full;
                self.font.src_size = data.filesize;

            })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error);
                });
        },

    }
}

</script>
<style scoped>
.btn-save {
    width: 150px;
}

.buttons-block {
    padding-left: 20px !important;
}
.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 8px;
}

.checkbox-block {
    margin-top: 40px;
    margin-left: 40px;
}

.btn-file {
    display: none;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
}

.label-checkbox {
    margin-right: 10px
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    margin-top: 15px;
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.inline-link span {
    padding: 3px;
    border-radius: 4px;
    font-size: 18px;
}

.bg-danger {
    background-color: rgba(255, 70, 50, 0.5) !important;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.device1 {
    display: inline-block;
    /*width: 281px;*/
    /*height: 609px;*/
    width: 337px;
    height: 731px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 40px;
}

.device2 {
    display: inline-block;
    /*width: 310px;*/
    /*height: 552px;*/
    width: 372px;
    height: 662px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 50px;
}

.device3 {
    display: inline-block;
    /*width: 384px;*/
    /*height: 640px;*/
    width: 461px;
    height: 614px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 50px;
}

.mt30 {
    margin-top: 30px;
}

#ajaxForm, #ajaxForm2 {
    position: relative;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Fonts/Edit.vue